import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Ng5SliderModule } from 'ng5-slider';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ComboDatepickerModule } from 'ngx-combo-datepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaModule, RECAPTCHA_V3_SITE_KEY, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { NgxSpinnerModule } from "ngx-spinner";

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { CotizadorAutoComponent } from './cotizador-auto/cotizador-auto.component';

import { JwtInterceptor } from './jwt.interceptor';
import { CotizadorHogarComponent } from './cotizador-hogar/cotizador-hogar.component';
import { CotizadorTecnologiaComponent } from './cotizador-tecnologia/cotizador-tecnologia.component';
import { LandingComponent } from './landing/landing.component';

import { SanitizeHtmlPipe } from './sanitize-html.pipe';
import { PlanesRecomendadosComponent } from './blocks/planes-recomendados/planes-recomendados.component';
import { ContactComponent } from './contact/contact.component';
import { QuotePipe } from './pipes/quote.pipe';
import { CotizacionCoberturasComponent } from './blocks/cotizacion-coberturas/cotizacion-coberturas.component';
import { CoberturasSecundariasComponent } from './blocks/coberturas-secundarias/coberturas-secundarias.component';
import { AsistenciasComponent } from './blocks/asistencias/asistencias.component';
import { ContinuarProcesoComponent } from './blocks/continuar-proceso/continuar-proceso.component';

import es from '@angular/common/locales/es';
import { DecimalPipe, registerLocaleData } from '@angular/common';
import { HogarContenidoComponent } from './blocks/hogar-contenido/hogar-contenido.component';
import { FooterComponent } from './blocks/footer/footer.component';
import { HeaderComponent } from './blocks/header/header.component';
import { ProteccionDatosComponent } from './blocks/proteccion-datos/proteccion-datos.component';
import { TecnologiaAsistenciasComponent } from './blocks/tecnologia-asistencias/tecnologia-asistencias.component';
import { TecnologiaAyudaComponent } from './blocks/tecnologia-ayuda/tecnologia-ayuda.component';
import { SendMailCotizacionComponent } from './blocks/send-mail-cotizacion/send-mail-cotizacion.component';
import { TecnologiaTcComponent } from './blocks/tecnologia-tc/tecnologia-tc.component';
import { ConfirmacionDatosComponent } from './blocks/confirmacion-datos/confirmacion-datos.component';
import { CotizadorBiciComponent } from './cotizador-bici/cotizador-bici.component';
import { BiciAsistenciasComponent } from './blocks/bici-asistencias/bici-asistencias.component';
import { BiciSidebarDatosPersonalesComponent } from './blocks/bici-sidebar-datos-personales/bici-sidebar-datos-personales.component';
import { BiciStepsComponent } from './blocks/bici-steps/bici-steps.component';
import { BiciLegalesComponent } from './blocks/bici-legales/bici-legales.component';
import { BiciConfirmacionDatosComponent } from './blocks/bici-confirmacion-datos/bici-confirmacion-datos.component';
import { BiciVerMasAsistenciasComponent } from './blocks/bici-ver-mas-asistencias/bici-ver-mas-asistencias.component';
import { BiciVerNumeroSerieComponent } from './blocks/bici-ver-numero-serie/bici-ver-numero-serie.component';
import { CotizadorTecnologiaOpc1Component } from './cotizador-tecnologia-opc1/cotizador-tecnologia-opc1.component';
import { Tecno1SidebarComponent } from './blocks/tecno1-sidebar/tecno1-sidebar.component';
import { CotizadorBiciOpc1Component } from './cotizador-bici-opc1/cotizador-bici-opc1.component';
import { CotizadorBiciOpc2Component } from './cotizador-bici-opc2/cotizador-bici-opc2.component';

registerLocaleData(es);

@NgModule({
  declarations: [
    AppComponent,
    CotizadorAutoComponent,
    CotizadorHogarComponent,
    CotizadorTecnologiaComponent,
    LandingComponent,
    SanitizeHtmlPipe,
    PlanesRecomendadosComponent,
    ContactComponent,
    QuotePipe,
    CotizacionCoberturasComponent,
    CoberturasSecundariasComponent,
    AsistenciasComponent,
    ContinuarProcesoComponent,
    HogarContenidoComponent,
    FooterComponent,
    HeaderComponent,
    ProteccionDatosComponent,
    TecnologiaAsistenciasComponent,
    TecnologiaAyudaComponent,
    SendMailCotizacionComponent,
    TecnologiaTcComponent,
    ConfirmacionDatosComponent,
    CotizadorBiciComponent,
    BiciAsistenciasComponent,
    BiciSidebarDatosPersonalesComponent,
    BiciStepsComponent,
    BiciLegalesComponent,
    BiciConfirmacionDatosComponent,
    BiciVerMasAsistenciasComponent,
    BiciVerNumeroSerieComponent,
    CotizadorTecnologiaOpc1Component,
    Tecno1SidebarComponent,
    CotizadorBiciOpc1Component,
    CotizadorBiciOpc2Component,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    Ng5SliderModule,
    NgxSpinnerModule,
    SlickCarouselModule,
    ComboDatepickerModule,
    NgbModule,
    RecaptchaModule
  ],
  entryComponents: [
    CoberturasSecundariasComponent,
    AsistenciasComponent,
    ContinuarProcesoComponent,
    ProteccionDatosComponent,
    SendMailCotizacionComponent,
    TecnologiaTcComponent,
    ConfirmacionDatosComponent,
    BiciConfirmacionDatosComponent,
    BiciVerMasAsistenciasComponent,
    BiciVerNumeroSerieComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: '6Ldj4McZAAAAAOHtfFoBU1ARYmw8soXYxgpu--i1',
      } as RecaptchaSettings,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
